import React from 'react'
import { Setters } from 'src/features/atoms/glove/us/Components'
import { OrderPageTemplate } from 'src/Components/Domain/OrderPageTemplate'
import { gloveReducer } from 'src/features/atoms/glove/us/slice/glove'
import { State, PartialAction } from 'src/types'
import { useLocale, useTransition } from 'src/locales/useLocale'
import { BaseModelSelector } from 'src/Components/Domain/BaseModelSelector'
import { atomsUsBaseModels } from 'src/features/atoms/glove/us/constants/baseModel'
import { SET_FIGURE_PANEL_NUMBER } from 'src/features/atoms/glove/us/constants/actionType'

const AtomsUs: React.FC = () => {
  const { t } = useLocale()
  const models = atomsUsBaseModels(t)
  const { isFirstRendered } = useTransition('us')
  const [state, dispatch] = React.useReducer(gloveReducer, t.INITIAL_STATE_US_GLOVE) as [State, React.Dispatch<PartialAction>]
  const { figurePanelNum } = state
  const handleFigurePanelNum = (_, newValue: 0 | 1) => dispatch({ ...state, type: SET_FIGURE_PANEL_NUMBER, figurePanelNum: newValue })

  if (!isFirstRendered) return <></>
  return (
    <>
      <OrderPageTemplate
        breadcrumbTrail={`${t.HARD} / ATOMS / ${t.INFIELDER}`}
        brand={'atoms'}
        {...{ figurePanelNum, state, dispatch, handleFigurePanelNum }}
      >
        <BaseModelSelector {...{ state, models, dispatch }} filterLogic={() => true} />
        <Setters {...{ state, figurePanelNum, dispatch }} />
      </OrderPageTemplate>
    </>
  )
}

export default AtomsUs
